module.exports = __webpack_public_path__ + "static/media/fl-cover-small.5f7db319.png";